import { IBlockDefinition, IBlockLayout, IBlockProps, IDropPanelConfig } from '@fox/blocks';
import { FORM_DROP_PANEL_TYPE } from '../../../form-block-types';
import { useFormEventContext } from '../../form-event-context';
import { SurveyState, useFormRuntimeContext } from '../../form-runtime-context';
import { RenderBlockComponent } from '../../render-block-component';
import { generateFormFinalPage } from '../form-block/default-final-page-layout';
import { SectionBlock } from '../section-block/section-block';

function FormDropPanelBlock({
	props
}: IBlockProps<
	IDropPanelConfig & {
		finalPage?: {
			id: string;
			props: {
				innerLayout: {
					layouts: IBlockLayout[];
				};
				title: string;
			};
			title: string;
			type: string;
		};
	}
>) {
	const { currentPage, sections, surveyState } = useFormRuntimeContext();
	const { waitlistSubmitted, event } = useFormEventContext();

	const DEFAULT_WAITLIST_MESSAGE = "Thanks for joining our waitlist! We'll let you know once a spot becomes available.";
	if (surveyState === SurveyState.submitted && waitlistSubmitted) {
		return <SectionBlock lastPage {...generateFormFinalPage(event?.customWaitlistMessage || DEFAULT_WAITLIST_MESSAGE)} />;
	}
	if (surveyState === SurveyState.submitted) {
		const finalPage = props.finalPage || generateFormFinalPage();
		return <SectionBlock lastPage {...finalPage} />;
	}

	return props.columns.map((_, i) => {
		const contents = props.columnContents.find(content => content.columnIndex === i)?.items ?? [];
		const currentBranchId = sections[currentPage]?.branchId;
		const currentSection = contents.find(c => c.props.branchId === currentBranchId);

		if (!currentSection?.props?.innerLayout?.layouts) return <></>;
		const layouts = currentSection.props.innerLayout.layouts;
		return layouts.map(layout => {
			return <RenderBlockComponent {...layout} key={layout.id} />;
		});
	});
}

export const FormDropPanelBlockRunTime: IBlockDefinition<IDropPanelConfig> = {
	type: FORM_DROP_PANEL_TYPE,
	Component: FormDropPanelBlock
};
